import { render, staticRenderFns } from "./InsuranceSettingsTab.vue?vue&type=template&id=2e942a4b&"
import script from "./InsuranceSettingsTab.vue?vue&type=script&lang=js&"
export * from "./InsuranceSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports